<template>
  <div class="card mb-3">
    <h4 class="card-header">
      Tags
    </h4>
    <div class="card-body">
      <ul class="nav d-flex flex-row">
        <li
          v-for="tag in tags"
          :key="tag.id"
          class="nav-item btn-light btn p-0"
          :class="{'bg-green' : $route.query.tag == tag.id, 'bg-green-fade': $route.query.tag != tag.id}"
        >
          <span>
            <a
              class="text-white nav-link"
              :class="{'active': $route.query.tag == tag.id}"
              @click.prevent="toggleTag(tag.id)"
            >{{ tag.name }}</a>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    tags: Array
  },
  methods: {
    toggleTag(tag) {

      // Unsetting
      if (this.$route.query.tag == tag) {
        this.unsetTag();
      } else {
        this.setTag(tag);
      }
    },
    setTag(tag) {
      if (this.$route.query.category) {
        this.$router.push({
          query: { tag: tag, category: this.$route.query.category }
        })
      } else {
        this.$router.push({
          query: { tag: tag }
        })
      }
    },
    unsetTag() {
      let query = Object.assign({}, this.$route.query);
      delete query.tag;
      this.$router.replace({ query });
    }
  }
}
</script>
